import XtractTableNew from './XtractTableNew/XtractTable.jsx'

export default XtractTableNew